import {SearchItem, SearchResultDto} from "../search/search-table.dto.res";
import {VehicleRepairDto} from "./vehicle-repair.dto";

export class SearchVehicleRepairRes extends SearchResultDto {

  public override readonly items: SearchVehicleRepairItem[] = [];

  constructor(init?: Partial<SearchVehicleRepairRes>) {
    super(init);
    if (init?.items) {
      this.items = init.items.map((i) => new SearchVehicleRepairItem(i));
    } else {
      this.items = [];
    }
  }
}

export class SearchVehicleRepairItem extends VehicleRepairDto implements SearchItem {

  public override readonly id!: string;

  constructor(init?: Partial<SearchVehicleRepairItem>) {
    super(init);
    Object.assign(this, init);
  }
}
